import { type LinkTrackingEvent, TrackObject } from ".";

import { useAnalyticsTracker } from ".";

export type StakingEvent = LinkTrackingEvent; // Add more staking events here

export const useStakingAnalytics = () =>
  useAnalyticsTracker<StakingEvent>(TrackObject.STAKING);
